import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule, DatePipe } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { FieldValidatorComponent } from "./field-validator/field-validator.component";
import { TypeRaceComponent } from "./type-race/type-race.component";
import { CarrouselCarsComponent } from "./carrousel-cars/carrousel-cars.component";
import { ModalScheduleComponent } from "./type-race/modal-schedule/modal-schedule.component";
import { ModalCommentPage } from "./modal-comment/modal-comment.page";
import { ModalDefaultComponent } from "./modal-default/modal-default.component";
import { GenerateLinkComponent } from "./generate-link/generate-link.component";
import { KitchenTypesComponents } from "./kitchen-types/kitchen-types.component";
import { LazyLoadImageModule } from "ng-lazyload-image";
import { DashboardMapComponent } from "./dashboard-map/dashboard-map.component";
import { GoogleMapsModule } from "@angular/google-maps";
import { StarRatingComponent } from "./star-rating/star-rating.component";
import { ReservationFormComponent } from "./reservation-form/reservation-form.component";
import { QRCodeComponent } from "angularx-qrcode";
import { PaymentComponent } from "./payment/payment.component";
import {
  StripeElementsDirective,
  StripePaymentElementComponent,
} from "ngx-stripe";
import { PaymentCompleteComponent } from "../driver/payment-complete/payment-complete.component";
import { WithdrawalModalComponent } from "./withdrawal-modal/withdrawal-modal.component";
import { WaitingHoursPickerComponent } from "./waiting-hours-picker/waiting-hours-picker.component";

const SHARED_COMPONENTS = [
  FieldValidatorComponent,
  TypeRaceComponent,
  CarrouselCarsComponent,
  ModalScheduleComponent,
  ModalCommentPage,
  ModalDefaultComponent,
  GenerateLinkComponent,
  KitchenTypesComponents,
  DashboardMapComponent,
  StarRatingComponent,
  ReservationFormComponent,
  PaymentComponent,
  PaymentCompleteComponent,
  WithdrawalModalComponent,
  WaitingHoursPickerComponent,
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    LazyLoadImageModule,
    GoogleMapsModule,
    QRCodeComponent,
    StripeElementsDirective,
    StripePaymentElementComponent,
  ],
  declarations: [...SHARED_COMPONENTS],
  exports: [...SHARED_COMPONENTS],
  providers: [DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsModule {}
